import { useState, FunctionComponent, useEffect, useContext } from 'react';
import { IconClose, IconErrorAlert } from '@lmig/lmds-react-icons';
import './Alert.scss';
import { AlertsContext } from './AlertsContext';
import { useLocalStorage } from 'Utilities/UseStorage';
import { Alert, IAlertsContext } from './Models/Alerts';
import RichText from 'Feature/PageContent/Shared/Tiles/RichText';

const AlertBanner: FunctionComponent = () => {
  const [alert, setAlert] = useState<Alert | null>(null);
  const [alertList, setAlertList] = useState<Alert[] | null>(null);
  const [dismissed, setDismissed] = useLocalStorage<string[]>('dismissed_banner_alerts', [], undefined);
  const alertsContext = useContext<IAlertsContext>(AlertsContext);

  useEffect(() => {
    alertsContext.getAlerts();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (alertsContext.alerts)
      setAlertList(alertsContext.alerts.filter((alert) => alert.Type === 'Alert' && !dismissed?.includes(alert.Id)));
  }, [alertsContext, dismissed]);

  useEffect(() => {
    if (alertList && alertList.length && !dismissed?.includes(alertList[0].Id)) setAlert(alertList[0]);
    else setAlert(null);
  }, [alertList, dismissed]);

  const setDismissedAlert = (alertId: string) => {
    setDismissed({ data: [...(dismissed ?? []).filter((x) => x != alertId), alertId] });
  };

  return (
    <>
      {alert?.Id && (
        <div className="alert-banner-container">
        <div className="alert-banner">
          <div className="alertBannerIconContainer">
            <IconErrorAlert size={{ sm: '24' }} color="negative"></IconErrorAlert>
          </div>
          <div className="alertBannerContentContainer">
            <div className="alertBannerHeader">{alert.Headline}</div>
            <RichText className="alertBannerContent" content={alert.Description} />
          </div>
          {/* dont broadcast dismissing a banner alert so that alerts mailbox will continue to display it*/}
          <div className="alertBannerIconClose" onClick={() => setDismissedAlert(alert.Id)}>
            <IconClose size={{ base: '16' }} color="gray"></IconClose>
          </div>
        </div>
      </div>
      )}
    </>
  );
};

export default AlertBanner;
